import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { profileStore } from "src/stores/profile-store";
import { utilsStore } from "src/stores/utils-store";
import { findPermissionsByPath } from "src/utils/find-permissions";
import { useShallow } from "zustand/react/shallow";

let isSetDefaultOpenKey = false;
const useNavigationMenu = () => {
  const profile = profileStore(useShallow((state) => state.profile));
  const currentActiveMenus = utilsStore(useShallow((state) => state.currentActiveMenus));
  const location = useLocation();
  const [current, setCurrent] = useState("1");
  const [activeMenu, setActiveMenu] = useState<string[]>([]);
  const [permissions, setPermissions] = useState<string[] | null>([]);

  const onClick = (e: any) => {};

  const onPathChange = useCallback(() => {
    const path = location.pathname.toLowerCase();
    const tmpPermissions = findPermissionsByPath(path, profile?.menus || []);
    setPermissions(tmpPermissions);
    setCurrent(path);
  }, [location.pathname, profile?.activeCompany]);

  const configDefaultActiveMenu = useCallback(() => {
    const path = location.pathname.toLowerCase();
    if (path !== "/" && !isSetDefaultOpenKey) {
      const opened = [];
      if (path.includes("/setting")) opened.push("/setting");
      else if (path.includes("/vocs-inventory")) {
        opened.push("/vocs-inventory");
        const extractPath = path.split("/");
        if (extractPath.length >= 4) opened.push(`/vocs-inventory/${extractPath[2]}`);
      }
      setActiveMenu(opened);
      isSetDefaultOpenKey = true;
    }
  }, [location.pathname]);

  useEffect(() => {
    onPathChange();
    configDefaultActiveMenu();
  }, [location.pathname, onPathChange]);

  useEffect(() => {
    // console.log("[Hools] activeMenu : ", currentActiveMenus);
    if (currentActiveMenus && currentActiveMenus.length > 0) setActiveMenu(currentActiveMenus);
  }, [currentActiveMenus]);

  return {
    current,
    onClick,
    activeMenu,
    setActiveMenu,
    permissions,
  };
};

export default useNavigationMenu;
